<template>
  <div class="card-wrapper">
    <!-- <LanguageS class="language-btn-box"></LanguageS> -->
    <slot></slot>
    <div class="card-btn-box" v-if="showBtn">
      <van-button @click="changeStep" class="btn">{{ btnMsg }}</van-button>
    </div>
  </div>
</template>
<script>
import LanguageS from './language.vue';
export default {
  components: {
    LanguageS,
  },
  props: {
    btnMsg: String,
    showBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    changeStep() {
      this.$emit('changeStep');
    },
  },
};
</script>
<style lang="scss">
.card-wrapper {
  display: flex;
  //   justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  width: calc(100% - 48px);
  max-width: 600px;
  height: fit-content;
  max-height: 80%;
  overflow-y: auto;
  background-color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  .card-btn-box {
    height: 40px;
    margin-top: 20px;
    .btn {
      width: 184px;
      font-size: 17px;
      font-weight: 500;
      background: linear-gradient(to bottom, #ffd814, #ffa031);
      border: 1px solid #fff;
    }
  }
}
</style>
